module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;

    interface IClocksAlertJSON extends IAlertJSON {
        minutesEarly: number;
        minutesLate: number;
    }

    class MeevoEmployeeLocksConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$translate'
        ];

        public params: IParams;
        public data: ISingleMoverData;

        public timeRange: number[];

        public clocksEarly: number;
        public clocksLate: number;

        get dataForReview() {
            return [
                `${this.$translate.instant(this.data.label)} ${this.clocksEarly} ${this.$translate.instant('LABEL_MINUTES_EARLY')}`,
                `${this.$translate.instant(this.data.label)} ${this.clocksLate} ${this.$translate.instant('LABEL_MINUTES_LATE')}`
            ];
        }

        get alertConfiguration() {
            return {
                minutesEarly: this.clocksEarly,
                minutesLate: this.clocksLate
            }
        }

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected $translate: angular.translate.ITranslateService) {
            super(alertsManagerService);

            this.timeRange = _.range(0, 61, 15);

            this.clocksLate = this.clocksEarly = 15;
        }

        onEdit(alertJson: IClocksAlertJSON) {
            this.clocksEarly = alertJson.minutesEarly;
            this.clocksLate = alertJson.minutesLate;
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoEmployeeLocksConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/employee-clocks-config/employee-clocks-config.component.html',
            controller: MeevoEmployeeLocksConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<',
            }
        });
}
